<div class="mode-control">
  <div class="row h-100 align-content-center justify-content-between">
    <div
      class="col-auto mode-control-button pointer-hover mode-control-button-select"
      [style.background-color]="
        data!.backgroundColor ? data!.backgroundColor : '#FFF'
      "
      [style.background-image]="
        data!.backgroundImage
          ? 'url(\'' + data!.backgroundImage + '\')'
          : 'inherit'
      "
      (click)="onButtonClick()"
      (mousedown)="onButtonTouchStart()"
      (mouseup)="onButtonTouchEnd()"
      (mouseleave)="onButtonTouchEnd()"
    >
      <div class="row h-100 align-content-center">
        <div
          [class]="
            'col text-center ' + (data!.color ? data!.color : 'color-medium')
          "
        >
          <div class="mode-control-button-icon">
            <i [class]="data!.icon"></i>
          </div>
          <div class="mode-control-button-text fw-bold text-uppercase fs-14">
            {{ data!.label | translate }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
